/* eslint-disable no-empty */
import { ResponseBasketballGetUserFeed } from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const basketballUserFeedApi = createApi({
  reducerPath: 'basketballUserFeedApi',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    fetchFeed: builder.query<ResponseBasketballGetUserFeed, { page: number }>({
      query: ({ page }) => `v2/user/basketball/feed?page=${page}`,
      serializeQueryArgs: ({ endpointName }) => endpointName,
      merge: (currentCache, newItems) => {
        if (currentCache?.data) {
          if (newItems?.current_page === 1) {
            return newItems;
          } else {
            return {
              ...currentCache,
              ...newItems,
              data: [...currentCache.data, ...newItems.data],
            };
          }
        }
        return newItems;
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.page !== previousArg?.page;
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const { reducerPath, reducer, middleware, useLazyFetchFeedQuery } =
  basketballUserFeedApi;
